export const lightTheme = {
  body: "#E2E2E2",
  text: "#FFF",
  toggleBorder: "#FFF",
  gradient: "linear-gradient(#39598A, #79D7ED) fixed",
};

export const darkTheme = {
  body: "#282c34",
  text: "#FAFAFA",
  toggleBorder: "#6B8096",
  gradient:
    "linear-gradient(rgba(36,40,47,1) 12%, rgba(40,44,52,1) 66%) fixed;",
};
